module.exports = __webpack_public_path__ + "img/quali-banner-768.12c865d3.jpg";